export default {
  STL_MANDIBULAR: 'stl_mandibular',
  STL_MAXILLARY: 'stl_maxillary'
}